import LegalPage from "@/components/feature/LegalPage";
import { termsSections } from "@/mocks/legalData";

export default function TermsPage() {
  return (
    <LegalPage
      breadcrumb="Terms & Conditions"
      badge="Legal"
      title="Terms & Conditions"
      updated="August 20, 2026"
      sections={termsSections}
    />
  );
}